module.exports = __webpack_public_path__ + "static/media/plus.5af51bb4.svg";